import { IClassname } from '@/lib/shared/model/classname';

export const PrivatePool = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 29C2.92826 29 3.8185 28.6427 4.47487 28.0067C5.13125 27.3707 5.5 26.5081 5.5 25.6087C5.5 26.5081 5.86875 27.3707 6.52513 28.0067C7.1815 28.6427 8.07174 29 9 29C9.92826 29 10.8185 28.6427 11.4749 28.0067C12.1313 27.3707 12.5 26.5081 12.5 25.6087C12.5 26.5081 12.8687 27.3707 13.5251 28.0067C14.1815 28.6427 15.0717 29 16 29C16.9283 29 17.8185 28.6427 18.4749 28.0067C19.1313 27.3707 19.5 26.5081 19.5 25.6087C19.5 26.5081 19.8687 27.3707 20.5251 28.0067C21.1815 28.6427 22.0717 29 23 29C23.9283 29 24.8185 28.6427 25.4749 28.0067C26.1313 27.3707 26.5 26.5081 26.5 25.6087C26.5 26.5081 26.8687 27.3707 27.5251 28.0067C28.1815 28.6427 29.0717 29 30 29M5.5 5.82609V5.26087C5.5 4.66125 5.74583 4.08619 6.18342 3.66219C6.621 3.2382 7.21449 3 7.83333 3C8.45217 3 9.04566 3.2382 9.48325 3.66219C9.92083 4.08619 10.1667 4.66125 10.1667 5.26087V16.5652C10.1667 18.5853 10.6333 21.0576 11.9808 21.9642C12.2982 22.1778 12.6972 22.2174 13.0833 22.2174M17.1667 5.82609V5.26087C17.1667 4.66125 17.4125 4.08619 17.8501 3.66219C18.2877 3.2382 18.8812 3 19.5 3C20.1188 3 20.7123 3.2382 21.1499 3.66219C21.5875 4.08619 21.8333 4.66125 21.8333 5.26087V16.5652C21.8333 18.5853 22.3 21.0576 23.6475 21.9642C23.9648 22.1778 24.3638 22.2174 24.75 22.2174M10.1667 13.1739H21.8333M10.1667 8.65217H21.8333M10.2145 17.6957H21.8812"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
